import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import {
  AttempsUserResponse,
  CIFINUserModel,
  CIFINUserResponse,
  UserState,
} from '../models/user.model';
import { PublicTokenResponse } from '../models/auth.model';
import { environment } from '../../../environments/environment';

export interface UserServiceState {
  valid: boolean;
  user: UserState | null;
  puk: string | null;
  iccd: string | null;
  phone: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class UserService {
  ids: Record<number, number> = {};

  sessionUrl = environment.authService;
  userUrl = environment.userService;
  validationUrl = environment.retryService;

  constructor(private http: HttpClient) {}

  private _currentUser = new BehaviorSubject<UserServiceState>({
    valid: true,
    user: null,
    puk: null,
    iccd: null,
    phone: null,
  });

  public readonly currentUser$ = this._currentUser.asObservable();

  public getAuthToken(): Observable<PublicTokenResponse> {
    return this.http.post<PublicTokenResponse>(this.sessionUrl, {
      service: '9370afad-59c4-4ad9-867d-a8ad2502068f',
    });
  }

  public setState(newState: Partial<UserServiceState>): void {
    const currentState = this._currentUser.getValue();
    this._currentUser.next({ ...currentState, ...newState });
  }

  validateUserData({
    documentNumber,
    documentType,
    expeditionDate,
  }: CIFINUserModel): Observable<CIFINUserResponse> {
    return this.getAuthToken().pipe(
      switchMap((tokenResponse: PublicTokenResponse) => {
        return this.http.get<CIFINUserResponse>(
          `${this.userUrl}?documentNumber=${documentNumber}&documentType=${documentType}&expeditionDate=${expeditionDate}`,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenResponse.data.token}`,
            },
          },
        );
      }),
    );
  }

  canUseService(
    documentType: string,
    documentId: number,
    expeditionDate: string,
  ): Observable<AttempsUserResponse> {
    return this.getAuthToken().pipe(
      switchMap((tokenResponse: PublicTokenResponse) => {
        return this.http.post<AttempsUserResponse>(
          `${this.validationUrl}?documentype=${documentType}&documentnumber=${documentId}&documentdate=${expeditionDate}`,null,
          {
            headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${tokenResponse.data.token}`
            },
          },
        );
      }),
    )
  }
}
